import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("voyagemarkt_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("voyagemarkt_token");
    if (token && !user) {
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("voyagemarkt_user", JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem("voyagemarkt_token");
      });
    }
    // eslint-disable-next-line
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("voyagemarkt_token", r.data.token);
      localStorage.setItem("voyagemarkt_user", JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally {
      setLoading(false);
    }
  };

  const register = async (payload) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/register", payload);
      localStorage.setItem("voyagemarkt_token", r.data.token);
      localStorage.setItem("voyagemarkt_user", JSON.stringify(r.data.user));
      setUser(r.data.user);
      return r.data.user;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("voyagemarkt_token");
    localStorage.removeItem("voyagemarkt_user");
    setUser(null);
  };

  // Used by the reset-password flow: hydrate the session with the
  // freshly-issued token + user payload returned from the backend.
  const setSession = (token, freshUser) => {
    localStorage.setItem("voyagemarkt_token", token);
    localStorage.setItem("voyagemarkt_user", JSON.stringify(freshUser));
    setUser(freshUser);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, setSession }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
